import Container from "@client/content/Containers/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import * as React from "react";
import Content from "./Content/container";

import "./style.less";

export type MapProps = RootContainerProps & {
  hasUser: boolean;
};

export interface ActionProps {}

export default (props: ActionProps & MapProps) => (
  <Container {...getContainerProps(props)} className="wsc_content_member_affiliate_dashboard">
    {props.hasUser ? <Content {...getRootContainerProps(props)} /> : null}
  </Container>
);
